import { formatBRL } from "@utils/currency";

export function formatDate(iso?: string) {
  if (!iso) return "-";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("pt-BR");
}

export function calculateTotal(price?: number, quantity?: number) {
  if (price == null || !quantity) return "-";
  return formatBRL(price * quantity);
}

export function formatQty(qty?: number) {
  const n = qty ?? 0;
  return n.toLocaleString("pt-BR");
}

export function formatItemTotal(price?: number, qty?: number) {
  if (price == null) return "-";
  const liters = qty ?? 0;
  // se "price" já for o total, troque para: formatBRL(price)
  return formatBRL(price * liters);
}

export function normalizeStatusLabel(status?: string) {
  if (!status) return "-";
  if (status === "BLOQUEADO") return "Bloqueado";
  if (status === "LIBERADO") return "Liberado";
  return status;
}

export function getStatusColor(status?: string) {
  switch (status) {
    case "BLOQUEADO":
      return "warning.main";
    case "LIBERADO":
      return "success.main";
    case "ERRO":
      return "error.main";
    default:
      return "text.primary";
  }
}
